<template>
    <form ref="form" @submit="handleResetPassword" novalidate>
        <div class="modal-dialog" style="min-width: 400px">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Reset Password</h5>
                </div>
                <div class="modal-body">
                    <div class="alert alert-danger" v-if="errorMessage">
                        {{errorMessage}}
                    </div>
                    <div class="alert alert-danger" v-if="errorDetails">                        
                        <ul id="error-details">
                            <li v-for="detail in errorDetails.split(',')" :key="detail">
                                {{ detail }}
                            </li>
                        </ul>
                    </div>
                    <div class="alert alert-success" v-if="successMessage">
                        {{successMessage}}
                    </div>
                    <div class="form-group row mb-2">
                        <div class="row">
                            <div class="col">
                                <div class="input-group mb-3">
                                    <input v-bind:type="[showPassword ? 'text' : 'password']"
                                        class="form-control"
                                        v-model="password"
                                        required
                                        :disabled="busy"
                                        data-lpignore="true"
                                        placeholder="Password"
                                        ref="password"
                                        />
                                        <span class="input-group-text" @click="passwordToggle">
                                        <alzata-icon :icon="showPassword ? 'far/eye' : 'far/eye-slash'" />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>                    
                    <div class="text-center">
                        <button type="submit" class="btn btn-primary text-center" :disabled="busy">{{busy ? 'Reseting...' : 'Reset Password'}}</button>
                    </div>
                </div>
                <!-- <div class="modal-footer bg-light small" style="justify-content: space-between">
                    <router-link v-if="$router.hasRoute('alzata:account/login')" :to="{ name: 'alzata:account/login' }">Sign In</router-link>
                    <router-link v-if="$router.hasRoute('alzata:account/create')" :to="{ name: 'alzata:account/create' }">Sign Up</router-link>
                </div> -->
            </div>
        </div>
    </form>
</template>

<script>

export default {
    name: 'AlzataResetPassword',
    data: () => ({
        password: '',
        errorMessage: null,
        errorDetails: null,
        showPassword: false,
        busy: false,
        formWasValidated: false,
    }),
    mounted() {
        this.$refs.password.focus();
    },
    methods: {        
        async handleResetPassword(evt) {
            evt.preventDefault();
            this.errorMessage = null;
            this.errorDetails = null;
            this.busy = true;
            let query = this.$route.query;

            try {
                const result = await this.apiClient.resetPassword(query.UserGuid, query.Token, this.password);
                if (result.success) {
                    this.successMessage = "Password Has Been Reset.";
                    window.setTimeout(() => this.$router.replace('/account/login'), 5000);
                }
                else {
                    this.errorMessage = "Failed To Reset Password.";
                    this.errorDetails = result.displayMessage;
                    window.setTimeout(() => this.$refs.password.focus(), 5000);
                }
            }
            finally {
                this.busy = false;
            }
        },
        passwordToggle() {
            this.showPassword = !this.showPassword;
        }
    },
};
</script>